import createImageUrlBuilder from '@sanity/image-url';

const builder = createImageUrlBuilder({
    projectId: 'lhkgj8kr',
    dataset: 'production',});

export const urlFor = (source) => {
    return builder.image(source);
};